import script from "./Calendar.vue?vue&type=script&lang=ts"
export * from "./Calendar.vue?vue&type=script&lang=ts"

import "./calendar.scss?vue&type=style&index=0&lang=scss"

const __exports__ = script;

export default __exports__